import { useMemo } from 'react'

import { FloraButton, Flex, FloraTypography } from '@grupoboticario/flora-react'

import { EVENT_TYPES } from '@/constants/benefitIds'
import { generateSecureId } from '@/utils/idGenerator/idGenerator'

import EventDayItem from './EventDayItem'
import * as S from './EventDaysSection.styles'

const EventDaysSection = ({ values, setFieldValue }) => {
  const addDiaItem = () => {
    const currentItems = values.days || []

    const newItem = {
      id: generateSecureId('dia'),
      date: '',
      startTime: '',
      endTime: '',
      ticketQuantity: '',
      limitPerCpf: values.type === EVENT_TYPES.FACTORY_VISIT ? '1' : ''
    }
    setFieldValue('days', [...currentItems, newItem])
  }

  const updateDiaItem = (index, field, value) => {
    const currentItems = values.days || []
    const updatedItems = [...currentItems]
    const limitPerCpf = 'limitPerCpf'

    if (values.type === EVENT_TYPES.FACTORY_VISIT && field === limitPerCpf) {
      updatedItems[index] = { ...updatedItems[index], [field]: '1' }
    } else {
      updatedItems[index] = { ...updatedItems[index], [field]: value }
    }

    setFieldValue('days', updatedItems)
  }

  const deleteDiaItem = (index) => {
    const newDias = values.days.filter((_, i) => i !== index)
    setFieldValue('days', newDias)
  }

  const diasItems = useMemo(
    () =>
      Array.isArray(values.days) && values.days.length > 0
        ? values.days.map((item, index) => ({
            ...item,
            id: item.id || `dia-${index}`
          }))
        : [
            {
              id: `dia-default-0`,
              date: '',
              startTime: '',
              endTime: '',
              ticketQuantity: '',
              limitPerCpf: values.type === EVENT_TYPES.FACTORY_VISIT ? '1' : ''
            }
          ],
    [values.days, values.type]
  )

  return (
    <Flex direction="column" gap="$2">
      <FloraTypography css={S.sectionTitleCss} fontSize="bodyLargeStandard" fontWeight="medium">
        Datas do evento e regras de resgate
      </FloraTypography>

      {diasItems.map((dia, index) => (
        <EventDayItem
          canDelete={diasItems.length > 1}
          dia={dia}
          eventType={values.type}
          index={index}
          key={dia.id}
          onDelete={deleteDiaItem}
          onUpdate={updateDiaItem}
        />
      ))}

      <Flex align="center" css={S.addButtonRowCss} justify="end">
        <FloraButton css={S.addButtonCss} onClick={addDiaItem} size="small" type="button" hierarchy="secondary">
          + Adicionar dia
        </FloraButton>
      </Flex>
    </Flex>
  )
}

export default EventDaysSection
